<div class="row clearfix">
  <!-- Header graphic -->
  <div class="col-sm-12">
    <div class="gdpr-header-graphic"><span i18n>Access your data preferences</span></div>
  </div> 
  <!-- / End Header graphic -->
  <div class="col-sm-12 gdpr-content-area">
    <h1 class="gdpr-h1" i18n>Please enter the verification code that you have received.</h1>
    <!-- Code validation section -->
    <form>
      <div class="row clearfix ">
        <div class="col-lg-10 col-md-10 col-sm-12 gdpr-code-box">
          <div class="row clearfix">
            <div class="col-lg-1 col-md-12 col-sm-12"></div>
            <div class="col-lg-6 col-md-12 col-sm-12 form-group">
              <input type="text" class="form-control" i18n-placeholder placeholder="Please enter your code without spaces" name="name" [(ngModel)]="id" #name="ngModel" required i18n-placeholder>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 form-group">
              <button class="btn btn-block btn-primary takeme-btn" (click)="getContactByHashCode()" i18n>Take me to my data preferences</button>
            </div>
            <div class="col-lg-1 col-md-12 col-sm-12"></div>
          </div>
        </div>
      </div>
    </form>
    <!-- / End code validation section -->

  </div>
  <div class="col-md-12"><h2 class="gdpr-h2 title gdpr-h2-margin" i18n>Need assistance?</h2></div>
  <div class=" col-md-12 gdpr-para">
   <span i18n>Didn't receive a verification code? Questions?</span><br>
   <span i18n>Send an email to the <a href="mailto:data.preferences@ihsmarkit.com" class="gdpr-anchor" style="color:#00AB4E;" >IHS Markit Support Team</a></span>
  </div>
</div>
<div class="my-container">
  <ngx-loading [show]="loading"></ngx-loading>
</div>
